export default {
  /**
   * Không dùng phần mềm
   */
  Admin: 1,
  /**
   * Dùng phần mềm
   */
  View: 0,
};
